import { render } from "./CustomerCreationModal.vue?vue&type=template&id=0f5f705c"
import script from "./CustomerCreationModal.vue?vue&type=script&lang=js"
export * from "./CustomerCreationModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__